module.exports = __webpack_public_path__ + "img/play-store.dc9b03d0.png";